export default "__VITE_ASSET__be9d22ae__"